import contractIndicatorsReducer from "./contractIndicatorsReducer"
export default contractIndicatorsReducer